import JSON from "json-bigint";

export default function (value) {
  return JSON.stringify(value);
}
